var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimerPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg_icon",
    viewBox: "0 0 24.3 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243A53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.8,
    width: 8.7,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22,6.2l1,.9,1.3-1.5L21,2.6,19.6,4l1,.9L19.5,6a11.1,11.1,0,0,0-3-1.7V3.5H7.8v.8A12.3,12.3,0,0,0,12.2,28,12.2,12.2,0,0,0,24.3,15.7,11.7,11.7,0,0,0,21,7.4ZM12.2,26a10.3,10.3,0,0,1,0-20.5A10.2,10.2,0,0,1,22.3,15.7,10.2,10.2,0,0,1,12.2,26Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.6,
    y: 9.7,
    width: 2,
    height: 12.02
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 13.8,
    y: 9.7,
    width: 2,
    height: 12.02
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimerPause);
export default __webpack_public_path__ + "static/media/icon-timer-pause.015de7d3363f2ac9eda667b2fafffeb8.svg";
export { ForwardRef as ReactComponent };